export const licenseKey =
  'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogIjVhODZkZmZlLWU3NmMtNDYxNy05MjdjLWFlZDc3MDMzMDc5OCIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjUyCn0=.cKs+73rAqyqILkLvDhb1C2eFN+xikmTOzROkgkRdHsRuBZ5c2d/210ytVErUl1VphOi5aLdthAYn9QuR8Ue+P/UuF3C3cjxFSdXBO6gHAbW5oTVYqMKG2Mt8fTwMrqQXtOjoAw==';
